import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

const filter = createFilterOptions();

/**
 * Required to match on the **label**. Uses **value** as the key
 * @param {*} props
 * @returns
 */
const CreatableAutocomplete = ({
  id,
  value,
  options,
  setValue,
  fullWidth = false,
  required = false,
  disabled = false,
  label = '',
  error = false,
}) => {
  return (
    <Autocomplete
      freeSolo
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      renderInput={(params) => <TextField {...params} required={required} error={error} label={label} />}
      renderOption={(props, option) => {
        // render the option separately from rendering the selected option
        // eslint-disable-next-line react/prop-types
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            {option.label}
          </li>
        );
      }}
      id={id}
      data-cy={id}
      value={value}
      options={options ?? []}
      fullWidth={fullWidth}
      disabled={disabled}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        const { inputValue } = params;

        const isExisting = options.some((option) => inputValue === option.label);

        if (inputValue !== '' && !isExisting) {
          filtered.push({ inputValue, label: `Add "${inputValue}"` });
        }

        return filtered;
      }}
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
          setValue({ label: newValue });
        } else if (newValue && newValue.inputValue) {
          setValue({ label: newValue.inputValue });
        } else {
          setValue(newValue);
        }
      }}
      getOptionKey={(option) => option.value}
      getOptionLabel={(option) => {
        // Dynamically created option (label is 'Add...')
        if (typeof option === 'string') {
          return option;
        }
        if (option.inputValue) {
          return option.inputValue;
        }
        return option.label;
      }}
    />
  );
};

CreatableAutocomplete.propTypes = {
  id: PropTypes.string,
  value: PropTypes.object.isRequired,
  options: PropTypes.array,
  setValue: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
};

export default CreatableAutocomplete;
